import { Pipe, PipeTransform } from "@angular/core";
import { FILE_TYPE } from '@constants/FileType';
type FILE_TYPE_ICON = 'active' | 'default' | 'variant';

@Pipe({
  name: "fileTypeIcon",
})
export class FileTypePipe implements PipeTransform {
  private readonly ICONS: { [key: number]: { [key in 'active' | 'default' | 'variant']: string } } = {
    [FILE_TYPE.videos]: { active: "fas fa-video", default: "far fa-video", variant: "far fa-film" },
    [FILE_TYPE.audios]: { active: "fas fa-volume", default: "far fa-volume", variant: "far fa-waveform" },
    [FILE_TYPE.documents]: { active: "fas fa-print", default: "far fa-print", variant: "far fa-file-pdf" },
    [FILE_TYPE.interactive]: { active: "fas fa-chart-network", default: "far fa-chart-network", variant: "fas fa-shapes" },
    [FILE_TYPE.readingPlan]: { active: "fas fa-chart-network", default: "far fa-chart-network", variant: "fas fa-chart-network" },
    [FILE_TYPE.presentationsPlenaries]: { active: "fas fa-chart-network", default: "far fa-chart-network", variant: "fas fa-chart-network" },
    [FILE_TYPE.guides]: { active: "fas fa-book-user", default: "far fa-book-user", variant: "far fa-file-pdf" },
    [FILE_TYPE.placesInterest]: { active: "fas fa-book-user", default: "far fa-book-user", variant: "far fa-file-pdf" },
    [FILE_TYPE.softwareFree]: { active: "fas fa-file-pdf", default: "far fa-file-pdf", variant: "far fa-file-pdf" },
    [FILE_TYPE.educationalServices]: { active: "fas fa-file-pdf", default: "far fa-file-pdf", variant: "far fa-file-pdf" },
    [FILE_TYPE.help]: { active: "fas fa-file-pdf", default: "far fa-file-pdf", variant: "far fa-file-pdf" },
    [FILE_TYPE.textBooks]: { active: "fas fa-file-pdf", default: "far fa-file-pdf", variant: "far fa-file-pdf" },
    [FILE_TYPE.digitalTextBooks]: { active: "fas fa-file-pdf", default: "far fa-file-pdf", variant: "far fa-file-pdf" },
    [FILE_TYPE.presentations]: { active: "fas fa-volume", default: "far fa-volume", variant: "far fa-waveform" },
    [FILE_TYPE.dosage]: { active: "fas fa-file-pdf", default: "far fa-file-pdf", variant: "far fa-file-pdf" },
  };

  transform(value: number, args: FILE_TYPE_ICON = 'default'): string {
    const icons = this.ICONS[value] || {};
    const icon = icons[args] || "fas fa-book-user";
    return icon;
  }
}
